export default __webpack_public_path__ + "static/media/Flaticon.9b97d4a0.svg";